export default "__VITE_ASSET__DG5F3Nfk__"